import Service, {parseParams} from 'api';

export const list = (params = {}, config) => {
  const parsedParams = parseParams({
    sort: 'name',
    limit: 0,
    ...params,
  });

  return Service.get(`workmix?${parsedParams}`, config);
};

export const post = (data = {}, config = {}) => Service.post('workmix', data, config);
export const put = (id, data = {}, config = {}) => Service.put(`workmix/${id}`, data, config);
export const destroy = (id, config) => Service.delete(`workmix/${id}`, config);
export const attach = (id, areaOfExpertiseId, config) =>
  Service.delete(`areas_of_expertise/${areaOfExpertiseId}/workmix/${id}`, {}, config);
export const detach = (id, areaOfExpertiseId, config) => Service.delete(`areas_of_expertise/${areaOfExpertiseId}/workmix/${id}`, config);
